import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_Palette.scss';
const dummyArr = [1, 2, 3, 4, 5, 6, 7];
class PgDev_Palette_Renderer extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps) {
        return;
    }
    //######################### Logic #########################
    rgb2hex = (rgb) => {
        if (!rgb)
            return '';
        const color = `#${rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)?.splice(1)
            .map(n => parseInt(n, 10).toString(16).padStart(2, '0'))
            .join('').toUpperCase()}`;
        return color !== '#undefined' ? color : '';
    };
    isLight = (color) => {
        // Variables for red, green, blue values
        let r, g, b;
        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
            // If RGB --> store the red, green, blue values in separate variables
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
        }
        else {
            // If hex --> Convert it to RGB: http://gist.github.com/983661
            color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
            r = color >> 16;
            g = color >> 8 & 255;
            b = color & 255;
        }
        // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
        const hsp = Math.sqrt(0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b));
        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 170)
            return true;
        return false;
    };
    setColorTexts = () => {
        const elements = document.querySelectorAll('.square');
        //First Load
        if (!elements.length) {
            this.forceUpdate();
        }
        elements.forEach(element => {
            const color = window.getComputedStyle(element).getPropertyValue('background-color');
            const textColor = this.isLight(color) ? 'black' : 'white';
            element.innerHTML = element.innerHTML.length ? element.innerHTML + '\n' + this.rgb2hex(color) : this.rgb2hex(color);
            // @ts-ignore
            element.style.color = textColor;
        });
    };
    //######################### Render #########################
    renderSquare = (classname, i) => {
        const boxClassName = _className('square', classname);
        if (!i)
            return _jsx("div", { className: boxClassName });
        const str = i === 1 ? 'Base' : `(${i})`;
        return _jsx("div", { className: boxClassName, children: str });
    };
    renderWarms = () => {
        return _jsxs(LL_V_C, { className: 'warm-container', children: [_jsx("h1", { children: "Warms" }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('pink-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('ochre-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('orange-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('red-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('monochromatic-' + n, n)) })] });
    };
    renderColds = () => {
        return _jsxs(LL_V_C, { className: 'cold-container', children: [_jsx("h1", { children: "Colds" }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('black-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('gray-blue-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('dark-blue-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('dark-green-' + n, n)) }), _jsx("div", { className: 'color-row', children: dummyArr.map(n => this.renderSquare('purple-' + n, n)) })] });
    };
    renderGradiants = () => {
        return _jsxs(LL_V_C, { className: 'gradient-container', children: [_jsx("h1", { children: "Gradients" }), _jsxs("div", { className: 'gradients', children: [this.renderSquare('blue-gradient'), this.renderSquare('green-gradient'), this.renderSquare('orange-gradient'), this.renderSquare('blue-inverted-gradient'), this.renderSquare('blue--gray-gradient'), this.renderSquare('gray-gradient')] })] });
    };
    renderUniques = () => {
        return _jsxs(LL_V_C, { className: 'unique-container', children: [_jsx("h1", { children: "Uniques" }), _jsxs("div", { className: 'uniques', children: [this.renderSquare('unique-green'), this.renderSquare('unique-orange'), this.renderSquare('unique-light_blue'), this.renderSquare('unique-red'), this.renderSquare('unique-glowing_red'), this.renderSquare('unique-turquoise'), this.renderSquare('unique-green_select'), this.renderSquare('unique-light_blue_select')] })] });
    };
    render() {
        this.setColorTexts();
        return _jsxs(LL_V_L, { className: 'palette-container', children: [_jsxs(LL_H_C, { className: 'palette-container__row', children: [this.renderColds(), this.renderWarms()] }), this.renderGradiants(), this.renderUniques()] });
    }
}
export const PgDev_Palette = { name: 'Palette Test', key: 'palette-test', renderer: PgDev_Palette_Renderer };
